import request from './services/axios.js'

export default {
  //付费列表
  getGoodsByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadGoods/getGoodsByPage',
      method: 'get'
    })
  },
  //订单列表
  getOrderPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadOrder/getOrderPage',
      method: 'get'
    })
  },
  //导出订单信息
  exportOrderData: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadOrder/exportOrderData'
    })
  },
  //获取支付二维码链接
  getPayQRCode: (params) => {
    return request({
      params,
      url: '/epay/getPayQRCode.do',
      method: 'get'
    })
  },
  //微信H5支付 (手机浏览器支付)
  wxH5Pay: (params) => {
    return request({
      params,
      url: '/epay/wxH5Pay.do',
      method: 'get'
    })
  },
  //微信JSAPI支付 (公众号支付)
  wxJSAPIPay: (params) => {
    return request({
      params,
      url: '/epay/wxJSAPIPay.do',
      method: 'get'
    })
  },
  //接口调用请求说明
  queryOrderStatus: (params) => {
    return request({
      params,
      url: '/epay/activeQuery.do',
      method: 'get'
    })
  },
  //接口调用请求说明
  qizhiOrderPayAuth: (params) => {
    return request({
      data: params,
      url: '/qiZhi/orderPayAuth',
      method: 'post'
    })
  },
  setCharge: (params) => {
    return request({
      data: params,
      url: '/ebook/cloudReadGoods/paySetting',
      method: 'post',
      contenType: 'application/json'
    })
  },
  authSetting: (params) => {
    return request({
      data: params,
      url: '/ebook/cloudReadGoods/authSetting',
      method: 'post',
      contenType: 'application/json'
    })
  },
  //获取云阅读商品信息
  getGoodsInfo: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadGoods/getGoodsInfo'
    })
  },
  //获取云阅读商品信息
  queryOneBookReadable: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribe/queryOneBookReadable'
    })
  },
  //文章是否可以直接打开阅读信息查询
  queryArticleReadable: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribe/queryArticleReadable'
    })
  },
  //订阅作品
  addOrder: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadOrder/addOrder'
    })
  },
  //生成文章商品订单
  addArticleOrder: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadOrder/addArticleOrder'
    })
  },
  //商品信息
  getGoodsEbProductInfo: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadGoods/getGoodsEbProductInfo'
    })
  },
  //读者列表
  findReaderByPage: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribe/findReaderByPage'
    })
  },
  //添加白名单
  addSubscribe: (params) => {
    return request({
      data: params,
      url: '/ebook/cloudReadSubscribe/addSubscribe',
      method: 'post'
    })
  },
  //恢复停用授权
  setSubscribeStatus: (params) => {
    return request({
      params,
      url: '/ebook/cloudReadSubscribe/setSubscribeStatus'
    })
  }
}
